var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNh46(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.2839 6.9336L14.1414 2.58545L22.1739 17.9712L30.2063 2.69694L22.2839 6.9336ZM28.4468 8.15993L38.79 3.92327V11.6162L32.8481 14.2919C36.3692 17.1907 38.6799 21.5389 38.6799 26.333C38.6799 35.0293 31.1976 42.1647 22.0648 42.1647C12.822 42.1647 5.44971 35.1408 5.44971 26.333C5.44971 21.4274 7.76042 17.0792 11.5016 14.069L5.55974 11.3932V3.70029L15.7929 8.04844L17.4434 11.0587L21.1845 18.1941C17.0033 18.7516 13.8123 22.2078 13.8123 26.333C13.8123 30.7926 17.6635 34.4718 22.3949 34.4718C27.1264 34.4718 30.9776 30.9041 30.9776 26.333C30.9776 22.0963 27.5665 18.5286 23.1652 18.1941L26.6862 11.2817H26.7963L28.4468 8.15993Z",
    fill: "#FFDC00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNh46);
export default __webpack_public_path__ + "static/media/NH투자증권-46.1565932ede42820261148495c4ccc07d.svg";
export { ForwardRef as ReactComponent };